// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j_JIZ","col":"styles_col__3zTex"};